export const pantoptions = [
	  { value: 'Black', label: 'Black', parm: 'pants' },
	  { value: 'Blue', label: 'Blue', parm: 'pants' },
	  { value: 'Green Tartan', label: 'Green Tartan', parm: 'pants' },
	  { value: 'Red', label: 'Red', parm: 'pants' },
	  { value: 'Red Tartan', label: 'Red Tartan', parm: 'pants' },
	  { value: 'Tribe Colors', label: 'Tribe Colors', parm: 'pants' },
];